import CustomButton from "../../../../../../shared_components/CustomButton";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaGlobe, FaCube } from "react-icons/fa";
import { SiWebflow } from "react-icons/si";

const Organisations = () => {
    const organisations = [
        { id: 1, name: "Webflow", icon: SiWebflow },
        { id: 2, name: "Webflow", icon: SiWebflow },
        { id: 3, name: "Relume", icon: FaCube },
        { id: 4, name: "Relume", icon: FaCube },
        { id: 5, name: "Webflow", icon: SiWebflow },
        { id: 6, name: "Webflow", icon: SiWebflow },
        { id: 7, name: "Relume", icon: FaCube },
        { id: 8, name: "Relume", icon: FaCube },
    ];

    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 align-items-center">
                    <div className="col-12 col-md-6 mb-4 mb-md-0">
                        <h1>Organizations building with us</h1>
                        <p>
                            Trusted by companies and communities who believe in learning together.
                        </p>

                        <div className="d-flex align-items-center gap-3">
                            <CustomButton className="bg-transparent border text-dark">
                                Become
                            </CustomButton>
                            <a className="text-dark d-flex align-items-center">
                                Partner <MdKeyboardArrowRight />
                            </a>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="row mx-0">
                            {organisations.map((org) => {
                                const Icon = org.icon;
                                return (
                                    <div className="col-6" key={org.id}>
                                        <div className="d-flex p-3 mx-0 my-1  bg-card">
                                            <Icon className="mr-2 text-dark bg-light" size={24} />
                                            <h6>{org.name}</h6>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Organisations;
